import React, { useEffect, useState, useRef } from 'react';
import { useSelector } from 'react-redux';
import {
  Typography, Box, Modal,
} from '@material-ui/core';

import { loadStripe } from '@stripe/stripe-js';
import { Elements } from '@stripe/react-stripe-js';
import { useStripeCard } from '../hooks/useStripeCard';
// import styles from './SubscribeModal.module.css';
import {
  makeStyles
} from '@material-ui/core';
import StripeCardForm from './StripeCardForm';

const useStyles = makeStyles((theme) => ({
  paypalBtnBox: {
    position: 'relative',
    display: 'block',
  }
}));

const modalStyle = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '90%',
  maxWidth: '400px',
  bgcolor: 'background.paper',
  boxShadow: 24,
  p: 3,
  maxHeight: 'calc(100vh - 120px)',
  overflowY: 'auto'
};

/**
 * SaveCardModal
 *
 * Props:
 *   isOpen       boolean
 *   onClose      () => void
 *   onSaved      ({ customerId, paymentMethodId }) => void
 *   user         { customerId?, email, name }
 */

const StripeCardModal = (props) => {
  const { open, setOpen, user, onSaved, showToast } = props;
  const { step, error, stripePublishableKey, clientSecret, customerId, initSetup, saveCard, reset } = useStripeCard({
    customerId: user.stripe_customer_id || null,
    email: user.email,
    name: user.name,
  });

  const [stripePromise, setStripePromise] = useState(null);
  useEffect(() => {
    if (stripePublishableKey) {
      setStripePromise(loadStripe(stripePublishableKey));
    }
  }, [stripePublishableKey])

  // const user = useSelector((state) => state.session.user);
  const styles = useStyles();

  const didInit = useRef(false);

  useEffect(() => {
    if (!open || didInit.current) return;
    didInit.current = true;
    initSetup();
  }, [open, user?.id, initSetup]);

  const handleModalClose = () => {
    didInit.current = false;
    reset();
    setOpen(false);
  };

  const handleSave = async ({ stripe, elements, nickname }) => {
    const setupIntent = await saveCard({ stripe, elements, nickname });
    console.log(`handleSave({ customerId, paymentMethodId: setupIntent.payment_method });`, customerId, setupIntent?.payment_method);
    if (setupIntent) {
      onSaved({ customerId, paymentMethodId: setupIntent.payment_method });
      didInit.current = false;
      reset();
    }
  };

  //////////////////////// app modal close feature //////////////////////////////////////////
  const appModalCloseTimestamp = useSelector((state) => state.layout.appModalCloseTimestamp);
  useEffect(() => {
    if (appModalCloseTimestamp) {
      setOpen(false)
    }
  }, [appModalCloseTimestamp]);
  ///////////////////////////////////////////////////////////////////////////////////////////

  return (
    <>
      <Modal
        open={open}
        onClose={handleModalClose}
        aria-labelledby="parent-modal-title"
        aria-describedby="parent-modal-description"
      >
        <Box sx={modalStyle}>
          {/* <Typography id="paypalPaymentFormTitle" className='mt-3'>
            Pay with Paypal
          </Typography> */}

          <div className='text-center' style={{ marginTop: '1rem' }}>
            <div className={styles.overlay} role="dialog" aria-modal="true" aria-label="Save payment method">
              <div className={styles.modal} onClick={e => e.stopPropagation()}>
                {/* <div className={styles.header}>
                  <div className={styles.headerLeft}>
                    <div>
                      <p className={styles.title}>
                        {step === 'success' ? 'Card saved!' : 'Add payment method'}
                      </p>
                      <p className={styles.subtitle}>
                        {step === 'success' ? 'Your card has been securely stored.' : 'Your card details are encrypted and secure.'}
                      </p>
                    </div>
                  </div>
                </div> */}

                <div className={styles.body}>
                  {(!clientSecret || !stripePromise) ? (
                    <div className={styles.loadingWrap}>
                      <div className={styles.spinner} />
                      <p>Preparing secure form…</p>
                    </div>
                  ) : (
                    <Elements
                      stripe={stripePromise}
                      options={{
                        clientSecret,
                        appearance: {
                          theme: 'stripe',
                          variables: {
                            colorPrimary: '#2563eb',
                            colorBackground: '#ffffff',
                            colorText: '#111827',
                            colorDanger: '#dc2626',
                            fontFamily: '"DM Sans", system-ui, sans-serif',
                            borderRadius: '10px',
                            spacingUnit: '4px',
                          },
                          rules: {
                            '.Input': {
                              border: '1.5px solid #e5e7eb',
                              boxShadow: 'none',
                              padding: '10px 14px',
                            },
                            '.Input:focus': {
                              border: '1.5px solid #2563eb',
                              boxShadow: '0 0 0 3px rgba(37,99,235,0.12)',
                            },
                            '.Label': {
                              fontWeight: '500',
                              fontSize: '13px',
                              color: '#374151',
                            },
                          },
                        },
                      }}
                    >
                      <StripeCardForm
                        step={step}
                        error={error}
                        onSave={handleSave}
                      />
                    </Elements>
                  )}
                </div>

              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};

function LoadingState() {
  return (
    <div style={{ padding: '2rem 0', textAlign: 'center', color: '#888', fontSize: 14 }}>
      Loading payment form…
    </div>
  );
}

export default StripeCardModal;